module.exports = __webpack_public_path__ + "static/icon_milano_centro_nero-0ee18f1dd0b456776a58392f89c2dd2e.svg";